import { useNavigate } from "react-router-dom";
import { Typography, Stack, Button, Box } from "@mui/material";
import { useModal } from "../../../contexts/ModalContext";

interface Props {
  isBlockedToBuy?: boolean;
  isBlockedToBuyMessage?: string | null;
}

const Inactive = (props: Props) => {
  const { isBlockedToBuy, isBlockedToBuyMessage } = props;
  const modal = useModal();
  const navigate = useNavigate();

  return (
    <>
      <Typography variant="h5" sx={{ fontWeight: 700, color: "white" }}>
        Prezado(a), sócio(a).
      </Typography>
      <Typography variant="body1" sx={{ color: "white", py: 3 }}>
        {isBlockedToBuy && !isBlockedToBuyMessage && (
          <>No momento, a compra está liberada apenas para sócios ativos. </>
        )}
        {isBlockedToBuyMessage && isBlockedToBuyMessage}
        {!isBlockedToBuyMessage &&
          "Solicitamos gentilmente que acesse a área do sócio ou entre em contato com nossa central de atendimento através do botão abaixo para regularizar sua situação e prosseguir com a compra de sua camisa com desconto. "}
        {!isBlockedToBuy && !isBlockedToBuyMessage && (
          <>
            Caso queira realizar a compra sem desconto clique no botão "Comprar
            sem Desconto".
          </>
        )}
      </Typography>
      <Stack width="100%" direction={{ xs: "column", lg: "row" }} spacing={2}>
        <Button
          size="small"
          fullWidth
          variant="contained"
          onClick={() => {
            window.open("https://socio-americadenatal.futebolcard.com/login");
          }}
        >
          Acessar Área do Sócio
        </Button>
        <Button
          size="small"
          fullWidth
          variant="outlined"
          color="milky"
          onClick={() => {
            window.open(
              "https://api.whatsapp.com/send/?phone=5584999269953&text&type=phone_number&app_absent=0",
            );
          }}
        >
          Atendimento
        </Button>
        {!isBlockedToBuy && (
          <Button
            size="small"
            fullWidth
            variant="outlined"
            color="milky"
            onClick={() => {
              modal?.close();
            }}
          >
            Comprar sem desconto
          </Button>
        )}
      </Stack>
    </>
  );
};

Inactive.defaultProps = {
  isBlockedToBuy: false,
  isBlockedToBuyMessage: null,
};

export default Inactive;
